import parse from 'html-react-parser';
import sanitizeHtml, { defaults } from 'sanitize-html';

import { reactHtmlParserOptions } from '../../constants/reactHtmlParserOptions';
import { cleanHtmlString } from '../../utils';
import type { HtmlStringToReactProps } from './types';

export function HtmlStringToReact({ htmlString }: HtmlStringToReactProps) {
    try {
        if (typeof htmlString === 'string') {
            return parse(
                cleanHtmlString(
                    sanitizeHtml(htmlString, {
                        allowedTags: defaults.allowedTags.concat(['img']),
                    })
                ),
                reactHtmlParserOptions
            );
        }

        return htmlString?.map(string =>
            parse(
                cleanHtmlString(
                    sanitizeHtml(string, {
                        allowedTags: defaults.allowedTags.concat(['img']),
                    })
                ),
                reactHtmlParserOptions
            )
        );
    } catch (error) {
        return null;
    }
}
